module.exports = __webpack_public_path__ + "static/media/encontrar_licitacoes.fb4db06c.svg";